import { Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

export const BaseDrawer = ({ isOpen, onClose, children }: Props) => {
  return (
    <Drawer size="lg" placement="right" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent overflowY="auto">
        <DrawerCloseButton onClick={onClose} />
        {children}
      </DrawerContent>
    </Drawer>
  );
};
